import cn from 'classnames'
import React from 'react'

import {
  Button,
  type ButtonSizeValue,
  IconGiftDefault,
} from '@mc/design-system'
import { paths } from '@mc/paths'
import { useTranslation } from '@mc/i18n'
import { getPageSource } from '@mc/track-event'

import { PROMO_I18N_NAMESPACE } from '../../lib/constants'
import { trackCtaClicked } from '../../lib/events'
import styles from './GiftButton.module.scss'

interface GiftButtonProps {
  className?: string
  size?: ButtonSizeValue
  fullWidth?: boolean
  location: string
  href?: string // pen-5021_v2_global_ctas_promo_banner
}

export const GiftButton = ({
  className = '',
  size = 'md',
  fullWidth = false,
  location,
  href, // pen-5021_v2_global_ctas_promo_banner
}: GiftButtonProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <Button
      fullWidth={fullWidth}
      className={cn(
        'd-flex justify-content-center flex-gap-1',
        className,
        styles.alignItemsCenter,
      )}
      kind='tertiary'
      onClick={() =>
        trackCtaClicked({
          action: 'Gift',
          location,
          href: href || paths.gift,
          pageSource: getPageSource(),
        })
      }
      as='a'
      href={href || paths.gift}
      size={size}
    >
      <IconGiftDefault size='sm' />
      {t('common.cta.secondary')}
    </Button>
  )
}
